class SearchspringCrossSell extends WiroHTMLRenderer {
  constructor(modules = [], profileTag = "home", productIds) {
    super([SearchspringAPIModule, SearchspringBeaconModule, ...modules]);
    this.profileTag = this.dataset.profileTag || profileTag || "";
    this.productIds = productIds || this.dataset.productIds;
    this.placement = this.dataset.placement || "product-page";

    if (this.dataset.seedProducts) {
      try {
        this.seedProducts = JSON.parse(this.dataset.seedProducts);
      } catch (e) {
        this.seedProducts = null;
      }
    } else if (this.productIds) {
      this.seedProducts = [{ sku: String(this.productIds) }];
    }
  }

  async connectedCallback() {
    super.connectedCallback();

    const searchspringData = await this.modules.searchspring.sendRecommendRequest(
      this.profileTag,
      this.productIds ? { products: [this.productIds] } : {},
      3,
    );

    this.results = searchspringData.results;

    if (searchspringData.results.length === 0) {
      this.myDom = this.prepareStringForRender(`
        <p>No products found.</p>  
      `);
    } else {
      this.myDom = this.prepareStringForRender(`
        <div class="tw-text-black tw-flex tw-flex-col tw-gap-4 sm:tw-gap-2">
          ${searchspringData.results
            .map((item, index) => {
              const product = item.mappings.core;
              return `
              <div class="tw-flex tw-gap-4 tw-items-center" data-beacon-product-index="${index}">
                <div class="tw-bg-[#f5f2ec] tw-min-w-[100px] xl:tw-min-w-[94px] tw-rounded-[4px]">
                  <a href="${product.url}">
                    <img 
                      class="tw-size-[100px] xl:tw-size-[94px] tw-object-cover" 
                      src="${this.optimizeImageUrl(product.imageUrl, 200)}" 
                      srcset="${this.optimizeImageUrl(product.imageUrl, 100)} 100w, 
                              ${this.optimizeImageUrl(product.imageUrl, 200)} 200w, 
                              ${this.optimizeImageUrl(product.imageUrl, 300)} 300w"
                      sizes="(min-width: 1280px) 94px, 100px"
                      loading="lazy"
                      alt="${product.name}" 
                    />
                  </a>
                </div>
                <div class="tw-flex tw-w-full tw-gap-4 max-xl:tw-flex-col max-xl:tw-items-start">
                  <div>
                    <a href="${product.url}">
                      <p class="tw-font-semibold max-xl:tw-text-[14px] max-xl:tw-leading-[18px] tw-mb-2 xl:tw-mb-1">${product.name}</p>
                    </a>
                    <span class="tw-text-[13px] tw-text-[#444]">
                      from
                    </span> 
                    <span>
                      ${this.formatPrice(product.price)}
                    </span>
                  </div>
                  <a href="${product.url}" data-label="View product" class="tw-w-fit tw-inline-flex tw-justify-center tw-items-center tw-bg-black tw-text-white tw-transition-all tw-duration-200 tw-ease-in-out tw-cursor-pointer tw-no-underline tw-border-0 tw-uppercase tw-rounded-[4px] tw-font-bold tw-text-[13px] tw-leading-[20px] tw-px-3 tw-py-[10px] xl:tw-ml-auto tw-text-nowrap tw-min-h-0 tw-h-10 btn-flyup hover:tw-bg-[#3C3C3C]"><span>View product</span></a>
                </div>
              </div>`;
            })
            .join("")}
        </div>
      `);
    }

    this.render(this.myDom);

    // Beacon: render + impression
    if (this.modules.beacon && this.profileTag && this.results.length) {
      const seeds = this.seedProducts || this.modules.beacon.getSeedProducts();
      this.modules.beacon.sendRenderBatch(this.profileTag, this.placement, seeds, this.results, searchspringData.responseId);
      this.modules.beacon.sendImpressionBatch(this.profileTag, this.placement, seeds, this.results);
    }

    // Beacon: product click
    this._setupCrossSellClickTracking();
  }

  _setupCrossSellClickTracking() {
    if (!this.modules.beacon || !this.results) return;
    const self = this;

    this.addEventListener("click", (e) => {
      const link = e.target.closest("a[href]");
      if (!link) return;

      const wrapper = link.closest("[data-beacon-product-index]");
      if (!wrapper) return;

      const index = parseInt(wrapper.dataset.beaconProductIndex);
      if (!self.results[index]) return;

      const seeds = self.seedProducts || self.modules.beacon.getSeedProducts();
      self.modules.beacon.sendProductClickBatch(self.profileTag, self.placement, seeds, self.results[index]);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  formatPrice(price) {
    return `£${price}`;
  }

  optimizeImageUrl(imageUrl, width) {
    if (!imageUrl) return "";
    if (imageUrl.includes("cdn.shopify.com")) {
      const [baseUrl, queryString] = imageUrl.split("?");
      const cleanUrl = baseUrl.replace(/_\d+x\d+(\.[a-z]+)$/i, "$1");
      let version = "";
      if (queryString) {
        const params = new URLSearchParams(queryString);
        version = params.get("v") || "";
      }
      if (version) {
        return `${cleanUrl}?v=${version}&width=${width}`;
      } else {
        return `${cleanUrl}?width=${width}`;
      }
    }
    return imageUrl;
  }
}

if (!customElements.get("searchspring-cross-sell"))
  customElements.define("searchspring-cross-sell", SearchspringCrossSell);
